// extracted by mini-css-extract-plugin
module.exports = {"readMoreContainer":"ReadMore_readMoreContainer__eiyTK","content":"ReadMore_content__jOx9_","readMoreButton":"ReadMore_readMoreButton__KABz7"};